import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Grid } from '@material-ui/core';
import cn from 'classnames';

//assets
import styles from './modal.module.css';

function BasicModal({
    open,
    onClose,
    children,
    className,
    hideBackdrop = false,
    fullScreen = false,
    closeOnBackdropClick = false,
}) {
    const onBackdropClick = (e) => {
        e.preventDefault();
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            // MUI spreads BackdropProps over its own click handler, so leaving it out restores
            // close-on-tap-outside.
            BackdropProps={closeOnBackdropClick ? undefined : { onClick: onBackdropClick }}
            hideBackdrop={hideBackdrop}
        >
            <Grid
                component={'div'}
                className={cn(
                    styles.modalBodyWrapper,
                    fullScreen && styles.modalFullScreen,
                    className
                )}
            >
                {children}
            </Grid>
        </Modal>
    );
}

BasicModal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string,
    fullScreen: PropTypes.bool,
    hideBackdrop: PropTypes.bool,
    closeOnBackdropClick: PropTypes.bool,
};

export default BasicModal;
